import * as React from 'react'

import { subscribeToScoreEvents } from '../utils/commentScoreSessionManager'

export const useScoreSessionSync = (
  channelIds: string[],
  startSession: () => void,
  stopSession: () => void,
): void => {
  React.useEffect(() => {
    const unsubscribe = subscribeToScoreEvents({
      onStart: (id) => {
        if (channelIds.includes(id)) {
          startSession()
        }
      },
      onStop: (id) => {
        if (channelIds.includes(id)) {
          stopSession()
        }
      },
    })
    return unsubscribe
  }, [channelIds, startSession, stopSession])
}
